import React, { forwardRef } from "react";
import { AccordionHelper } from "components/displays";
import { Form, FormBuilder } from "@redriver/cinnamon";
import PenSvg from "features/../../../shared/assets/pen.svg";
import SaveSvg from "features/../../../shared/assets/save.svg";
import { IconButton } from "features/../../../shared/components/buttons";
import { Button } from "semantic-ui-react";
import {
  getPhysicalDocumentOption,
  setPhysicalDocumentOption,
} from "features/Dealers/DealerOffice/Settings/actions";

const PhysicalDocumentOptions = forwardRef(
  ({ settingsId, collapsed, toggleVisibility }, ref) => {
    const toggleOptions = [
      { value: false, text: "No" },
      { value: true, text: "Yes" },
    ];
    return (
      <div ref={ref}>
        <AccordionHelper
          title="Physical Document"
          collapsed={collapsed}
          toggleVisibility={toggleVisibility}
        >
          <FormBuilder
            initialReadOnly
            loadAction={getPhysicalDocumentOption}
            loadParams={settingsId}
            submitAction={setPhysicalDocumentOption}
            submitParams={{ settingsId }}
            renderForm={(formProps, state, events) => {
              return (
                <Form {...formProps}>
                  <div className="header">
                    <div className="actions form-header">
                      {!state.readOnly && (
                        <Button
                          primary
                          className="cancel-title-action"
                          content="Cancel"
                          onClick={events.onReset}
                        />
                      )}
                      <IconButton
                        primary
                        icon={state.readOnly ? PenSvg : SaveSvg}
                        content={state.readOnly ? "Edit" : "Save"}
                        onClick={() =>
                          state.readOnly
                            ? events.onToggleReadOnly()
                            : events.onSubmit({ reset: ["readOnly"] })
                        }
                        className={
                          !state.readOnly ? "positive-title-action" : null
                        }
                      />
                    </div>
                  </div>
                  <Form.Dropdown
                    field="physicalDocumentFlowEnabled"
                    label="Allow use of Physical Document"
                    options={toggleOptions}
                    placeholder="Select an option"
                  />
                </Form>
              );
            }}
          />
        </AccordionHelper>
      </div>
    );
  },
);

export default PhysicalDocumentOptions;
